interface TopbarProps {
  appName: string;
  routeLabel: string;
  breadcrumb?: string;
  provider?: string;
  status?: string;
}

export function Topbar({ appName, routeLabel, breadcrumb, provider, status }: TopbarProps) {
  return (
    <header className="shell-topbar">
      <span className="shell-topbar__title">{appName}</span>
      <span className="shell-topbar__route">{routeLabel}</span>
      {breadcrumb && <span className="shell-topbar__breadcrumb">{breadcrumb}</span>}
      <span className="shell-topbar__spacer" />
      {provider && (
        <span className="shell-topbar__provider">
          <span className="shell-topbar__provider-dot" />
          {provider}
        </span>
      )}
      {status && <span className="shell-topbar__status">{status}</span>}
    </header>
  );
}
